import { render } from "./modaleEvaluation.vue?vue&type=template&id=20d528cc"
import script from "./modaleEvaluation.vue?vue&type=script&lang=js"
export * from "./modaleEvaluation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__